export const getVideoElements = (): HTMLCollectionOf<HTMLVideoElement> => {
    return document.getElementsByClassName(
        "cropVideo"
    ) as HTMLCollectionOf<HTMLVideoElement>
}
